/**
 * Custom Hook: useKaryawan
 * Manages karyawan data fetching and state
 */

import { useState, useEffect, useCallback } from "react";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { normalizeKaryawanPayload } from "../utils/dataTransformers";

export const useKaryawan = (karyawanNama = null) => {
  const [karyawanOptions, setKaryawanOptions] = useState([]);
  const [selectedKaryawanId, setSelectedKaryawanId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchKaryawanList = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(API_ENDPOINTS.KARYAWAN_JADWAL_HARI_INI, {
        headers: { Accept: "application/json" },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);

      const data = await res.json();
      const mapped = normalizeKaryawanPayload(data);
      setKaryawanOptions(mapped);

      // Auto-select karyawan if name is provided in URL
      if (karyawanNama && mapped.length > 0) {
        const decodedNama = decodeURIComponent(karyawanNama);
        const foundKaryawan = mapped.find(
          (k) => k.nik.toLowerCase() === decodedNama.toLowerCase()
        );
        if (foundKaryawan) {
          setSelectedKaryawanId(foundKaryawan.nik);
        }
      }
    } catch (err) {
      console.error("Gagal memuat data karyawan:", err);
      setError(err.message);
      setKaryawanOptions([]);
    } finally {
      setLoading(false);
    }
  }, [karyawanNama]);

  useEffect(() => {
    fetchKaryawanList();
  }, [fetchKaryawanList]);

  const selectedKaryawan = karyawanOptions.find(
    (k) => k.nik === selectedKaryawanId
  );

  return {
    karyawanOptions,
    selectedKaryawanId,
    setSelectedKaryawanId,
    selectedKaryawan,
    loading,
    error,
    refetch: fetchKaryawanList,
  };
};

export default useKaryawan;
